define("shared/components/shared/social/linkedin-modal", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/service", "@ember/array", "@glimmer/tracking", "rsvp", "ember-concurrency-decorators"], function (_exports, _component, _templateFactory, _component2, _service, _array, _tracking, _rsvp, _emberConcurrencyDecorators) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/service",0,"@ember/array",0,"@glimmer/tracking",0,"rsvp",0,"ember-concurrency-decorators",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal
    @close={{@handleClose}}
    {{did-insert (perform this.fetchUserData)}}
    as
    |modal|
  >
    <modal.card> 
      <modal.card-header>
        <p class="o--modalHeader__title"> {{t "linkedin.select_profile_title"}} </p>
      </modal.card-header>
      <modal.card-body class="has--scroll">  
        {{#if this.isRunning}}
          <div class="cLB--container">
            <Shared::LoadingSpinner />
          </div>
        {{else}}
          {{#if this.profile}}
            <p class="u--text--bold u--m__b__sm u--m__t__lg"> {{t "linkedin.personal_profile"}} </p>
            <div class="u--row u--m__tb">
              <div class="u--col__6">
                <Shared::Ui::Button
                  @type="outline"
                  @additional="block"
                  @onClick={{perform @addLinkedinProfile this.profile.id}}
                >
                  <div class="o--user">
                    <img class="o--user__avatar is--square" src={{this.profile.avatar_url}} >
                    <span class="o--user__title u--p__t__sm">{{this.profile.name}}</span>
                  </div>
                </Shared::Ui::Button>
              </div>
            </div>
          {{/if}}
  
          {{#if this.organizations}}
            <p class="u--text--bold u--m__b__sm u--m__t__lg"> {{t "linkedin.pages"}} </p>
            <div class="u--row u--m__tb">
              {{#each this.organizations as |organization|}}
                <div class="u--col__6">
                  <Shared::Ui::Button
                    @type="outline"
                    @additional="block"
                    @onClick={{perform @addLinkedinProfile organization.id}}
                  >
                    <div class="o--user">
                      <img class="o--user__avatar is--square" src={{organization.avatar_url}} >
                      <span class="o--user__title u--p__t__sm">{{organization.name}}</span>
                    </div>
                  </Shared::Ui::Button>
                </div>
              {{/each}}
            </div>
          {{/if}}         
          <p class="u--m__t__lg"> 
            {{t "linkedin.select_profile_note"}}
            <Shared::Link
              @href="https://help.later.com/hc/articles/360063905933"
              @text={{t "shared_phrases.learn_more"}}
            />
          </p>
        {{/if}}
      </modal.card-body> 
  
      <modal.card-footer>
        <Shared::Ui::Button
          class="u--float--right"
          @type="outline"
          @text={{t "shared_words.cancel"}}
          @onClick={{@handleClose}}
        />
      </modal.card-footer>
    </modal.card>
  </Shared::Modal>
  
  */
  {
    "id": "oV1RSwSN",
    "block": "[[[8,[39,0],[[4,[38,1],[[28,[37,2],[[30,0,[\"fetchUserData\"]]],null]],null]],[[\"@close\"],[[30,1]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,2,[\"card\"]],null,null,[[\"default\"],[[[[1,\" \\n    \"],[8,[30,2,[\"card-header\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,2],[14,0,\"o--modalHeader__title\"],[12],[1,\" \"],[1,[28,[35,3],[\"linkedin.select_profile_title\"],null]],[1,\" \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,2,[\"card-body\"]],[[24,0,\"has--scroll\"]],null,[[\"default\"],[[[[1,\"  \\n\"],[41,[30,0,[\"isRunning\"]],[[[1,\"        \"],[10,0],[14,0,\"cLB--container\"],[12],[1,\"\\n          \"],[8,[39,5],null,null,null],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"profile\"]],[[[1,\"          \"],[10,2],[14,0,\"u--text--bold u--m__b__sm u--m__t__lg\"],[12],[1,\" \"],[1,[28,[35,3],[\"linkedin.personal_profile\"],null]],[1,\" \"],[13],[1,\"\\n          \"],[10,0],[14,0,\"u--row u--m__tb\"],[12],[1,\"\\n            \"],[10,0],[14,0,\"u--col__6\"],[12],[1,\"\\n              \"],[8,[39,6],null,[[\"@type\",\"@additional\",\"@onClick\"],[\"outline\",\"block\",[28,[37,2],[[30,3],[30,0,[\"profile\",\"id\"]]],null]]],[[\"default\"],[[[[1,\"\\n                \"],[10,0],[14,0,\"o--user\"],[12],[1,\"\\n                  \"],[10,\"img\"],[14,0,\"o--user__avatar is--square\"],[15,\"src\",[30,0,[\"profile\",\"avatar_url\"]]],[12],[13],[1,\"\\n                  \"],[10,1],[14,0,\"o--user__title u--p__t__sm\"],[12],[1,[30,0,[\"profile\",\"name\"]]],[13],[1,\"\\n                \"],[13],[1,\"\\n              \"]],[]]]]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"organizations\"]],[[[1,\"          \"],[10,2],[14,0,\"u--text--bold u--m__b__sm u--m__t__lg\"],[12],[1,\" \"],[1,[28,[35,3],[\"linkedin.pages\"],null]],[1,\" \"],[13],[1,\"\\n          \"],[10,0],[14,0,\"u--row u--m__tb\"],[12],[1,\"\\n\"],[42,[28,[37,8],[[28,[37,8],[[30,0,[\"organizations\"]]],null]],null],null,[[[1,\"              \"],[10,0],[14,0,\"u--col__6\"],[12],[1,\"\\n                \"],[8,[39,6],null,[[\"@type\",\"@additional\",\"@onClick\"],[\"outline\",\"block\",[28,[37,2],[[30,3],[30,4,[\"id\"]]],null]]],[[\"default\"],[[[[1,\"\\n                  \"],[10,0],[14,0,\"o--user\"],[12],[1,\"\\n                    \"],[10,\"img\"],[14,0,\"o--user__avatar is--square\"],[15,\"src\",[30,4,[\"avatar_url\"]]],[12],[13],[1,\"\\n                    \"],[10,1],[14,0,\"o--user__title u--p__t__sm\"],[12],[1,[30,4,[\"name\"]]],[13],[1,\"\\n                  \"],[13],[1,\"\\n                \"]],[]]]]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[4]],null],[1,\"          \"],[13],[1,\"\\n\"]],[]],null],[1,\"        \"],[10,2],[14,0,\"u--m__t__lg\"],[12],[1,\" \\n          \"],[1,[28,[35,3],[\"linkedin.select_profile_note\"],null]],[1,\"\\n          \"],[8,[39,9],null,[[\"@href\",\"@text\"],[\"https://help.later.com/hc/articles/360063905933\",[28,[37,3],[\"shared_phrases.learn_more\"],null]]],null],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]]],[1,\"    \"]],[]]]]],[1,\" \\n\\n    \"],[8,[30,2,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[8,[39,6],[[24,0,\"u--float--right\"]],[[\"@type\",\"@text\",\"@onClick\"],[\"outline\",[28,[37,3],[\"shared_words.cancel\"],null],[30,1]]],null],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[2]]]]],[1,\"\\n\"]],[\"@handleClose\",\"modal\",\"@addLinkedinProfile\",\"organization\"],false,[\"shared/modal\",\"did-insert\",\"perform\",\"t\",\"if\",\"shared/loading-spinner\",\"shared/ui/button\",\"each\",\"-track-array\",\"shared/link\"]]",
    "moduleName": "shared/components/shared/social/linkedin-modal.hbs",
    "isStrictMode": false
  });

  let LinkedInModalComponent = (_class = class LinkedInModalComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "alerts", _descriptor, this);

      _initializerDefineProperty(this, "errors", _descriptor2, this);

      _initializerDefineProperty(this, "linkedin", _descriptor3, this);

      _initializerDefineProperty(this, "organizations", _descriptor4, this);

      _initializerDefineProperty(this, "profile", _descriptor5, this);
    }

    get isRunning() {
      return this.fetchUserData.isRunning || this.args.addLinkedinProfile.isRunning;
    }

    *fetchUserData() {
      const getProfilePromise = this.linkedin.fetchLinkedinProfile.perform();
      const getOrganizationsPromise = this.linkedin.fetchLinkedinOrganizations.perform();
      const settledPromises = yield (0, _rsvp.allSettled)([getProfilePromise, getOrganizationsPromise]);
      this.profile = this._parseSettledPromise(settledPromises[0]);
      this.organizations = this._parseSettledPromise(settledPromises[1]);
    }

    _parseSettledPromise(_ref2) {
      let {
        state,
        reason,
        value
      } = _ref2;

      if (state === 'fulfilled') {
        return value;
      } else if (state === 'rejected') {
        const {
          error
        } = reason;
        this.errors.log(error);
        return;
      }
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "linkedin", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "organizations", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return (0, _array.A)();
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "profile", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "fetchUserData", [_emberConcurrencyDecorators.task], Object.getOwnPropertyDescriptor(_class.prototype, "fetchUserData"), _class.prototype)), _class);
  _exports.default = LinkedInModalComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, LinkedInModalComponent);
});